import { ref, watch } from "vue";
import { usePageScrollService } from "./use-page-scroll-service";

const modalsCounter = ref(0);

const { disablePageScroll, enablePageScroll } = usePageScrollService();

watch(modalsCounter, (newModalsCounter, oldModalsCounter) => {
    if (newModalsCounter < 0) {
        modalsCounter.value = 0;
        return;
    }

    if (!oldModalsCounter && newModalsCounter > 0) {
        disablePageScroll();
    } else if (oldModalsCounter > 0 && !newModalsCounter) {
        enablePageScroll();
    }
});

const addToStackedModals = () => {
    modalsCounter.value++;
};

const removeFromStackedModals = () => {
    if (modalsCounter.value <= 0) {
        return;
    }

    modalsCounter.value--;
};

export function useStackedModals() {
    return {
        addToStackedModals,
        removeFromStackedModals,
    };
}
